import * as React from 'react';
import { ErrorInfo } from 'react';
import { observer } from 'mobx-react';
import { errorStore } from './ErrorStore';
import { Dialog } from '@material-ui/core';
import { DialogTitle } from '@material-ui/core';
import { DialogContent } from '@material-ui/core';
import { DialogContentText } from '@material-ui/core';
import { DialogActions } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { translation } from '../i18n';

interface State {
  hasError: boolean;
}

@observer
export class ErrorBoundary extends React.Component<{}, State> {
  public state = {hasError: false};

  public componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({hasError: true});
    // You can also log the error to an error reporting service
  }

  public render() {
    if (this.state.hasError || errorStore.hasErrors) {
      return (
        <Dialog open={true}>
          <DialogTitle>{translation.t('errorBoundary.title')}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {translation.t('errorBoundary.body')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => window.location.reload()} color="primary">
              {translation.t('actions.reload')}
            </Button>
          </DialogActions>
        </Dialog>);
    }
    return this.props.children;
  }
}
